import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import ScrollInteraction from "../ui/ScrollInteraction";

const clientLogos = [
  "1 Buentipo.JPG",
  "10 Transfigura.jpg",
  "11 Tuscany.png",
  "12 Logo Propets.jpg",
  "13 Transporte Caravana.jpg",
  "14 Cusezar.jpg",
  "14 Terpel.png",
  "2 3Remos.JPG",
  "3 Antpack.JPG",
  "4 Noble.JPG",
  "5 Hermano.JPG",
  "6 Cerromatoso.jpg",
  "7 D1.png",
  "8 Frontera Energy.jpg",
  "9 Grupo Bios.jpg"
];

// Duplicar logos para efecto infinito
const duplicatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

const scrollAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-325px * 15)); }
`;

const ClientsSection: React.FC = () => {
  return (
    <Box
      id="clientes"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: "#1F2330", // Cambiado para juego de contraste
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Línea divisoria */}
       <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "10%",
            right: "10%",
            height: "1px",
            background:
              "linear-gradient(90deg, transparent, rgba(0, 225, 112, 0.4), transparent)",
            zIndex: 1,
          }}
        />

      <Container maxWidth="lg" sx={{ px: { xs: 4, md: 6 }, position: "relative", zIndex: 2 }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto", mb: 6, textAlign: "center" }}>
          <ScrollInteraction animationType="slide" delay={0.2}>
            <Typography
              variant="overline"
              sx={{
                fontSize: "0.6875rem",
                fontWeight: 400,
                letterSpacing: "0.08em",
                color: "#B8C5B8",
                mb: 2,
                textTransform: "uppercase",
                opacity: 0.9,
                display: "block",
              }}
            >
              Nuestros Clientes
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" },
                fontWeight: 700,
                mb: 3,
                color: "#FFFFFF",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
              }}
            >
              Con la confianza de grandes organizaciones
            </Typography>
          </ScrollInteraction>
        </Box>
      </Container>
      
      {/* Marquee de clientes */}
      <Box
        sx={{
          width: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          position: "relative",
          mb: 4,
          mt: 4,
          "&::before, &::after": {
            content: '""',
            position: "absolute",
            top: 0,
            width: "15%",
            height: "100%",
            zIndex: 2,
            pointerEvents: "none",
          },
          "&::before": {
            left: 0,
            background: "linear-gradient(to right, #1F2330 0%, transparent 100%)",
          },
          "&::after": {
            right: 0,
            background: "linear-gradient(to left, #1F2330 0%, transparent 100%)",
          },
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            animation: `${scrollAnimation} 40s linear infinite`,
            "&:hover": {
              animationPlayState: "paused",
            },
          }}
        >
          {duplicatedLogos.map((logo, index) => (
            <Box
              key={index}
              sx={{
                width: "325px",
                padding: "0 2rem",
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                height: "156px", // Para forzar un contenedor regular
              }}
            >
              <Box
                component="img"
                src={`/Logos Clientes/${logo}`}
                alt={`Cliente ${index + 1}`}
                sx={{
                  maxHeight: "104px",
                  maxWidth: "234px",
                  objectFit: "contain",
                  filter: "grayscale(100%) brightness(1.5)",
                  opacity: 0.6,
                  transition: "all 0.4s ease",
                  "&:hover": {
                    filter: "grayscale(0%) brightness(1)",
                    opacity: 1,
                    transform: "scale(1.05)",
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ClientsSection;
